export default "__VITE_ASSET__DmG1WzWf__"